import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

import { signOut, signInWithToken } from '../actions/auth'
import { clearMessage, getUserConfig } from '../actions/common'

import MsgBox from '../components/Layout/MsgBox'
import ModuleButton from '../components/Layout/ModuleButton'

import logo from '../img/logo-icesi.png'
import profile from '../img/User-Profile.jpg'
import history from '../utils/history'

import '../css/simple-sidebar.css'
import { List } from 'immutable';

const version = require('../../package.json').version;

class Layout extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showSignOut: false,
            showSideBar: true
        }
    }
    componentWillMount() {
        if (!this.props.isAuthenticated) {
            const params = new URLSearchParams(this.props.location.search);
            if (params.has("token")) {
                const token = params.get('token').slice(0, -8)
                const expire_date = params.get('token').slice(-8)
                this.props.signInWithToken(token, expire_date, this.props.location)
            } else {
                this.props.signOut()
            }
        } else {
            if (!this.props.user) {
                this.props.getUserConfig()
            }
        }
    }

    componentDidMount() {
        window.root.addEventListener('click', this.handleDocumentClick)
    }

    componentWillUnmount() {
        window.root.removeEventListener('click', this.handleDocumentClick)
    }

    componentWillUpdate(nextProps) {
        if (!nextProps.isAuthenticated) {
            this.props.signOut()
        }
    }

    componentDidUpdate() {
        this.props.clearMessage()
    }

    handleDocumentClick = (e) => {
        const dd1 = ReactDOM.findDOMNode(this.dd1)
        if (!dd1.contains(e.target)) {
            this.setState({ showSignOut: false })
        }
    }    

	render() {
        const { user } = this.props
        if (!user) return null

        if (this.props.message) {
            const { message } = this.props
            switch (message.get('type')) {
                case 'danger':
                    toast.error(message.get('message'), { bodyClassName: 'toastify-content toastify-danger' })
                    break
                case 'warning':
                    toast.warn(message.get('message'), { bodyClassName: 'toastify-content toastify-warning' })
                    break
                case 'success':
                    toast.success(message.get('message'), { bodyClassName: 'toastify-content toastify-success' })
                    break
                default:
                    toast.info(message.get('message'), { bodyClassName: 'toastify-content toastify-info' })
            }
        }

		return (
            <div className="body">
                <nav className="navbar navbar-default navbar-fixed-top" style={{ backgroundColor: '#F7F9FA', borderBottom: '1px solid #d2d6de' }}>
                    <div className="container-fluid">
                        <div style={{ background: '#F7F9FA' }}>
                            <a className="navbar-brand" style={{ width: '181px', background: '#f7f9fa', padding: '5px 25px' }}>
                                <img src={ logo } height="40" alt="logo" />
                            </a>
                        </div>
                        <div className="header-link hide-menu" onClick={ () => this.setState({ showSideBar: !this.state.showSideBar }) }>
                            <i className="fa fa-bars"></i>
                        </div>
                    </div>
                </nav>
                <div id="wrapper" className={ `${this.state.showSideBar  ? '' : 'toggled'}` }>
                    <div id="sidebar-wrapper">
                        <div className="text-center" style={{ background: '#fff', paddingTop: '25px', paddingBottom: '40px' }}>
                            <img className="profile-user-img img-responsive img-circle" src={ profile } alt="profile" />
                            <div style={{ paddingTop: '15px' }}>
                                <div>
                                    <small style={{ textTransform: 'uppercase', fontWeight: 'bold' }}>
                                        { user.get('username') }
                                    </small>
                                </div>
                                <div className="usertype">
                                    <div className="dropdown">
                                        {
                                            (user.get('es_superusuario') ?
                                                <a className="text-center dropdown-toggle" onClick={ e => { e.preventDefault(); this.setState({ showSignOut: true }) } }><small>Súper administrador <i className="fa fa-caret-down"></i></small></a>
                                            :   <a className="text-center dropdown-toggle" onClick={ e => { e.preventDefault(); this.setState({ showSignOut: true }) } }><small> Usuario <i className="fa fa-caret-down"></i></small></a> )
                                        }
                                        <ul className="dropdown-menu animated flipInX" ref={ (dd1) => this.dd1 = dd1 } style={{ width: '172px', margin: '0 5px', display: (this.state.showSignOut) ? 'block' : 'none' }}>
                                            <li><a onClick={ e => { e.preventDefault(); this.props.signOut() } }>Cerrar sesión</a></li>
                                            {
                                                (!user.get('ldap') &&
                                                    <li><a onClick={ e => history.push(window.FOLDER + '/cambiar-contrasena') }>Cambiar contraseña</a></li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ul className="sidebar-nav">
                            <ModuleButton id="home" caption="Inicio" expandible={ false } options={ List() } url="/" />
                            {
                                user.get('modulos').filter(x => x.get('en_menu')).sortBy(x => x.get('orden')).map(x => {
                                    return (
                                        <ModuleButton key={ x.get('id') } id={ x.get('id') } caption={ x.get('nombre') } expandible={ x.get('padre_id') === null && (x.get('url') === null || x.get('url') === '') } options={ x.get('modulos').filter(a => a.get('en_menu')).sortBy(a => a.get('orden')) } url={ x.get('url') } />
                                    )
                                })
                            }
                        </ul>
                    </div>

                    <div id="page-content-wrapper">
                        { this.props.children }
                        <div className="text-center" style={{ width: '100%', position: 'absolute', bottom: '0px', fontSize: '0.9em' }}>
                            <span style={{ color: '#c8c8c8' }}>Desarrollado por <a href="http://www.mawesi.net" target="_blank" rel="noopener noreferrer" style={{ color: '#b5b5b5' }}>MAWESI S.A.S.</a> | &copy; 2018 Mawesi &nbsp; | </span><span style={{marginLeft: '5px', color: '#c8c8c8', fontWeight:'bold'}}>{`v${version}`}</span>
                        </div>
                    </div>
                </div>
                <MsgBox />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        message: state.common.get('message'),
        isAuthenticated: state.auth.get('isAuthenticated'),
        user: state.common.get('user'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        signOut: () => dispatch(signOut()),
        clearMessage: () => dispatch(clearMessage()),
        getUserConfig: () => dispatch(getUserConfig()),
        signInWithToken: (t, ed, url) => dispatch(signInWithToken(t, ed, url))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)


// WEBPACK FOOTER //
// ./src/containers/Layout.jsx